import React from "react";
import { getMatchStreamingProps, getStreamingId } from "../../data/streaming/streamingUtils";
import Img from "../../common/Img";

export default function StreamingToggle(props) {
    const event = props.data;
    if (event == null) {
        return null;
    }

    let streamingId = null;
    const streamingMap = getMatchStreamingProps(event);
    if (streamingMap != null) {
        streamingId = getStreamingId(streamingMap[event.id]);
    }

    if (streamingId == null) {
        return null;
    }

    return (
        <Img className={props.className}
             src="icon_liveTV.svg"
             height="32px"
             width="32px"
             onClick={props.toggle}
        />
    );
}
